// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PorterStoreProductDetailApiModel from "../api-model/PorterStoreProductDetailApiModel.bs.js";

function decodeProduct(data) {
  return {
          code: data.code,
          name: data.name,
          description: data.description,
          is_active: data.is_active,
          list_amount_minor: data.list_amount_minor,
          sale_amount_minor: data.sale_amount_minor,
          currency_code: data.currency_code,
          created_at: data.created_at,
          updated_at: data.updated_at
        };
}

function decodeTranslation(data) {
  return {
          product_id: data.product_id,
          language_code: data.language_code,
          name: data.name,
          description: data.description,
          created_at: data.created_at
        };
}

function decodeImage(data) {
  return {
          product_id: data.product_id,
          image_url: data.image_url,
          display_order: data.display_order,
          created_at: data.created_at
        };
}

function decodeVariant(data) {
  return {
          product_id: data.product_id,
          sku: data.sku,
          size_code: data.size_code,
          stock_quantity: data.stock_quantity,
          is_active: data.is_active,
          created_at: data.created_at,
          updated_at: data.updated_at
        };
}

function decodePriceOverride(data) {
  return {
          product_id: data.product_id,
          geo_region_id: data.geo_region_id,
          list_amount_minor: data.list_amount_minor,
          sale_amount_minor: data.sale_amount_minor,
          currency_code: data.currency_code
        };
}

function decodeSupplier(data) {
  return {
          name: data.name,
          cashfree_vendor_id: data.cashfree_vendor_id,
          is_active: data.is_active,
          created_at: data.created_at
        };
}

function decodeAvailability(data) {
  return {
          product_id: data.product_id,
          supplier_id: data.supplier_id,
          supplier: decodeSupplier(data.supplier),
          geo_region_id: data.geo_region_id,
          is_active: data.is_active,
          priority: data.priority,
          created_at: data.created_at,
          updated_at: data.updated_at
        };
}

function decodeValidationTarget(data) {
  return {
          target_id: data.target_id,
          target_type: data.target_type
        };
}

function decodeValidationConfig(data) {
  return {
          max_allowed_count: data.max_allowed_count,
          rolling_window_days: data.rolling_window_days,
          required_product_id: data.required_product_id
        };
}

function decodeValidation(data) {
  return {
          target: decodeValidationTarget(data.target),
          validation_type: data.validation_type,
          scope: data.scope,
          geo_region_id: data.geo_region_id,
          config: decodeValidationConfig(data.config),
          is_active: data.is_active,
          created_at: data.created_at,
          updated_at: data.updated_at
        };
}

function decodeProductDetail(data) {
  return {
          product: decodeProduct(data.product),
          translations: Belt_Array.map(data.translations, decodeTranslation),
          images: Belt_Array.map(data.images, decodeImage),
          variants: Belt_Array.map(data.variants, decodeVariant),
          price_overrides: Belt_Array.map(data.price_overrides, decodePriceOverride),
          availability: Belt_Array.map(data.availability, decodeAvailability),
          validations: Belt_Array.map(data.validations, decodeValidation)
        };
}

function execute(json) {
  return decodeProductDetail(DeccoUtils$Catalyst.resolveResult(PorterStoreProductDetailApiModel.t_decode(json), "PorterStoreProductDetailEntityMapper.res"));
}

export {
  decodeProduct ,
  decodeTranslation ,
  decodeImage ,
  decodeVariant ,
  decodePriceOverride ,
  decodeSupplier ,
  decodeAvailability ,
  decodeValidationTarget ,
  decodeValidationConfig ,
  decodeValidation ,
  decodeProductDetail ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
